import { ModulesPermissions } from '../../utils/enums';
import { ConfigItem } from './types';

export const Configs: Record<string, ConfigItem> = {
  CookieConfig: {
    name: 'Cookie',
    permissionKey: ModulesPermissions.WEBFRAME_CONFIG_COOKIE,
  },
  CookieDeclarationConfig: {
    name: 'Cookie Declaration',
    permissionKey: ModulesPermissions.WEBFRAME_CONFIG_COOKIE_DECLARATION,
  },
  GlossaryConfig: {
    name: 'Glossary',
    permissionKey: ModulesPermissions.WEBFRAME_CONFIG_GLOSSARY,
  },
  HelpSectionConfig: {
    name: 'Help Section',
    permissionKey: ModulesPermissions.WEBFRAME_CONFIG_HELP_SECTION,
  },
};
